import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import AdminCommonListTable from '../layout/AdminCommonListTable'
import AdminAddressForm from 'admin/components/addresses/form/AdminAddressForm'
import { showSuccess, showError } from 'actions/Error'
import { Button, Grid, Typography, Chip } from '@material-ui/core'
import { adminAddressListVetting } from 'admin/components/addresses/actions/admin_address'
import { adminBeneficiaryVettingList } from './actions/admin_beneficiary_vetting'
import { Modal } from 'components/layout/Modal'
import { BasicMapWithMarker } from 'components/map/MapMarkers'

const NEW_ADDRESS_ID = '__new_address__'

export default function AdminVettingAddresses({ beneficiary_vetting_id, formik_props, inTabs }) {
  const dispatch = useDispatch()
  const is_loading = useSelector(
    () => !adminAddressListVetting.isReady() && adminAddressListVetting.isLoading()
  )
  const vetting = useSelector(() => adminBeneficiaryVettingList.getObject(beneficiary_vetting_id))
  const vetting_status = get(vetting, 'status')
  const actionsDisabled = vetting_status !== 'vetting_in_progress'
  const [editingAddressId, setEditingAddressId] = useState(null)
  const [addEditLabel, setAddEditLabel] = useState('New Address')
  const newAddressInitialValues = { beneficiary_vetting: beneficiary_vetting_id }

  useEffect(() => {
    if (!beneficiary_vetting_id) return
    dispatch(adminAddressListVetting.invalidateList())
    dispatch(adminAddressListVetting.updateListFilter(newAddressInitialValues))
    dispatch(adminAddressListVetting.fetchListIfNeeded())
  }, [dispatch, beneficiary_vetting_id])

  const onAddAddress = () => {
    setEditingAddressId(NEW_ADDRESS_ID)
  }

  const onEditAddress = (address_id) => {
    setAddEditLabel(`Editing ${address_id}`)
    setEditingAddressId(address_id)
  }

  const onStopEditingAddress = (res) => {
    dispatch(adminAddressListVetting.invalidateList())
    dispatch(adminAddressListVetting.fetchListIfNeeded())
    vetting.addresses.push(res)

    setEditingAddressId(null)
  }

  const onRemoveAddress = (address) => {
    if (!window.confirm('Are you sure you want to delete this address?')) return
    const onDone = (res) => {
      if (res.errors) {
        showError('Failed', 'Address is in use and could not be deleted')
      } else {
        showSuccess('Deleted', 'Address deleted')
        dispatch(adminAddressListVetting.invalidateList())
        dispatch(adminAddressListVetting.fetchListIfNeeded())
      }
    }
    dispatch(adminAddressListVetting.deleteObject(address.id)).then(onDone)
  }

  const onMakeDefaultAddress = () => {
    alert(
      'This address must be saved as the only default address. All other addresses should be saved as is_default: false'
    )
  }

  const columns = [
    {
      field: 'formatted_address',
      title: 'Address',
      render: (item) => (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography>
              <Typography variant="h5">{get(item, 'formatted_address')}</Typography>
              <div style={{ marginBottom: 10, marginTop: 10 }}>
                {get(item, 'is_default') ? (
                  <Chip label="Default Address" style={{ background: 'green', color: 'white' }} />
                ) : (
                  <Button
                    onClick={() => !actionsDisabled && item.onMakeDefaultAddress && item.onMakeDefaultAddress(item.id)}
                    size="small"
                    variant="outlined"
                    disabled={actionsDisabled}
                  >
                    Make Default Address
                  </Button>
                )}
              </div>
              City: {get(item, 'city_name')}
              <br />
              Province: {get(item, 'province_name')}
              <br />
              Latitude: {get(item, 'latitude')}
              <br />
              Longitude: {get(item, 'longitude')}
              <br />
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <BasicMapWithMarker
              lat={get(item, 'latitude')}
              lng={get(item, 'longitude')}
              width="100%"
              height={300}
              showDefaultUI
            />
          </Grid>
        </Grid>
      )
    }
  ]

  if (!beneficiary_vetting_id) return null

  return (
    <>
      <AdminCommonListTable
        add_label="Add Address"
        title="Address"
        onAddRow={actionsDisabled ? undefined : onAddAddress}
        onEditRow={actionsDisabled ? undefined : onEditAddress}
        canDelete={!actionsDisabled}
        is_loading={is_loading}
        columns={columns}
        item_list={adminAddressListVetting}
        noHeadings
        inTabs={inTabs}
      />
      {editingAddressId && (
        <Modal title={addEditLabel} onClose={() => setEditingAddressId(null)}>
          <AdminAddressForm
            newAddressInitialValues={newAddressInitialValues}
            address_id={editingAddressId === NEW_ADDRESS_ID ? null : editingAddressId}
            onDone={onStopEditingAddress}
          />
        </Modal>
      )}
    </>
  )
}
